import TenantService from "../tenant/TenantService"
import {TenantResponse} from "../../dtos/tenantResponse"
import axios from "axios"
import {getAxiosConfigWithAuth} from "../../utils/auth"
const tenantsvc = new TenantService()

const getCulture = async (tenantId: string, tenants: TenantResponse[]) => {
	let tenant: TenantResponse = await tenantsvc.getTenantDetails(tenantId, tenants)
	return tenant.defaultCulture
}

export default async function getDigitalDashboardUrl(
	shopperId: string,
	tenantId: string,
	tenants: TenantResponse[]
): Promise<string> {
	const culture: string = await getCulture(tenantId, tenants)
		.then((response) => {
			return response
		})
		.catch((e) => {
			return "en-ie"
		})
	const metadataUrl = `${
		process.env.REACT_APP_SUBMAN
	}/v1/canonical/vistaprint/${culture.toLowerCase()}/subscriptions:home?requestor=care-console`

	return axios
		.get(metadataUrl, {
			...getAxiosConfigWithAuth(),
			responseType: "text" as const,
		})
		.then((res) => {
			const url = res.data.replace(/^"|"$/g, "")

			return `${url}?careAgent=true&shopper_id=${shopperId}`
		})
		.catch((e) => {
			console.error("Failed to fetch canonical URL:", e)
			return ""
		})
}
